// extracted by mini-css-extract-plugin
export default {"root":"SideBar-root-40f2f998be552543a529d4ae5bf505a5"};